import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderImageComponent } from './dynamic-page-builder-image.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderImageDesignComponent } from './image-design/page-builder-image-design.component';

@NgModule({
    declarations: [
        PageBuilderImageDesignComponent, DynamicPageBuilderImageComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderImageComponent
    ]
})
export class PageBuilderImageModule {}